export default __webpack_public_path__ + "src/images/slider/32fe1934492416a5ccc34d795ad146a8-3.jpg";